var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___OTRWTG",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___OTRWTG",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___OTRWTG",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___OTRWTG",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___OTRWTG",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___OTRWTG",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___OTRWTG",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___OTRWTG",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___OTRWTG",
};

module.exports = exports;
